<template>
  <div class="site-background">
    <br aria-hidden="true" />
    <br aria-hidden="true" />
    <ProgressBars></ProgressBars>
    <br aria-hidden="true" />
    <br aria-hidden="true" />
    <br aria-hidden="true" />
    <div :class="getConclusionAreaClass()">
      <div :style="getStarCss()">
        <img :src="starImage" class="img-fluid" :alt="LG('CO_altStarImage')" />
      </div>
      <h1>{{ LG("CO_title") }}</h1>
      <br aria-hidden="true" />
      <!--<br v-show="principleNumber == 0" />
            <h2 v-show="principleNumber == 0" v-html="LG('CO_mainHeading')"></h2>
            <br aria-hidden="true"/>
            <h2 v-html="LG(getCurrentPrinciple().heading)"></h2>-->
      <div v-for="paragraph in getCurrentPrinciple().paragraphs" :key="paragraph.heading">
        <p v-if="paragraph.popover == null" v-html="LG(paragraph.text)"></p>
        <PopupLinker v-else :paragraph="LG(paragraph.text)" :content="LG(paragraph.popover)" :content2="LG(paragraph.popover2)"></PopupLinker>
      </div>
      <div v-show="isLastPage()">
        <br aria-hidden="true" />
        <strong
          ><p>
            <font-awesome-icon icon="download" class="leave-space" /><a target="_blank" v-on:click="onPDFClicked()" :href="getPdfPath()">{{ LG("CO_downloadPdfText") }}</a>
          </p></strong
        >
        <p>
          <strong>{{ LG("CO_finalizeMessage") }}</strong>
        </p>
      </div>
      <br aria-hidden="true" />
      <br aria-hidden="true" />
      <br aria-hidden="true" />
      <div class="centered-element">
        <b-button class="funky-shape funky-wider" v-on:click="onNextButtonClicked()">{{ getNextButtonLabel() }}</b-button>
      </div>
    </div>
    <br aria-hidden="true" />
    <br aria-hidden="true" />
    <div v-if="hasPDFAudio()">
      <AudioPlayer id="id-pdf-audio" :ref="getPDFAudioRef()" autoplay="no" :url="getPDFAudio()"></AudioPlayer>
    </div>
    <div v-if="hasIntroAudio()">
      <AudioPlayer id="id-conclusion-audio" :ref="getIntroAudioRef()" autoplay="yes" :url="getIntroAudio()"></AudioPlayer>
    </div>
  </div>
</template>

<script>
import PopupLinker from "@/components/PopupLinker.vue";
import ProgressBars from "../components/ProgressBars.vue";
import AudioPlayer from "../components/AudioPlayer.vue";

export default {
  components: {
    PopupLinker,
    ProgressBars,
    AudioPlayer,
  },
  data() {
    return {
      areaName: this.$route.params.areaName,
      situationName: this.$route.params.situationName,

      audioPDF: "/audio/partager/partager_conclusion_pdf.mp3",

      // Arrays
      situations: [
        {
          id: "id-situation-1",
          principles: [
            {
              paragraphs: [
                {
                  text: "CO_S1_P2_paragraph1",
                },
                {
                  text: "CO_S1_P2_paragraph2",
                },
              ],
            },
          ],
          pdfPath: "/pdf/MES1-PDF.pdf",
          //storyLinePath: "Storyline/scene1/story.html",
          storyLinePath: "jeu-questionnaire/situation1/jeu.html",
          storyLineReady: true,
          audioUrl: "/audio/scene1/L'accueil des familles_025.mp3",
        },
        {
          id: "id-situation-2",
          principles: [
            {
              heading: "CO_S2_P2_heading",
              paragraphs: [
                {
                  text: "CO_S2_P2_paragraph1",
                },
                {
                  text: "CO_S2_P2_paragraph2",
                },
              ],
            },
          ],
          pdfPath: "/pdf/MES2-PDF.pdf",
          storyLinePath: "jeu-questionnaire/situation2/jeu.html",
          storyLineReady: true,
          audioUrl: "/audio/scene2/L'écoute visible_021.mp3",
        },
        {
          id: "id-situation-3",
          principles: [
            {
              paragraphs: [
                {
                  text: "CO_S3_P1_paragraph1",
                },
                {
                  text: "CO_S3_P1_paragraph2",
                },
              ],
            },
          ],
          pdfPath: "/pdf/MES3-PDF.pdf",
          storyLinePath: "jeu-questionnaire/situation3/jeu.html",
          storyLineReady: true,
          audioUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_21.mp3",
        },
        {
          id: "id-situation-4",
          principles: [
            {
              //heading: "CO_S4_P2_heading",
              paragraphs: [
                {
                  text: "CO_S4_P2_paragraph1",
                },
                {
                  text: "CO_S4_P2_paragraph2",
                },
              ],
            },
          ],
          pdfPath: "/pdf/MES4-PDF.pdf",
          storyLinePath: "jeu-questionnaire/situation4/jeu.html",
          storyLineReady: true,
          audioUrl: "/audio/scene4/Ici, je suis chez moi_021.mp3",
        },
        {
          id: "id-situation-5",
          principles: [
            {
              paragraphs: [
                {
                  text: "CO_S5_P1_paragraph1",
                },
                {
                  text: "CO_S5_P1_paragraph2",
                },
              ],
            },
          ],
          pdfPath: "/pdf/MES5-PDF.pdf",
          storyLinePath: "jeu-questionnaire/situation5/jeu.html",
          storyLineReady: true,
          audioUrl: "/audio/scene5/Nature et découverte_021.mp3",
        },
        {
          id: "id-situation-6",
          principles: [
            {
              paragraphs: [
                {
                  text: "CO_S6_P1_paragraph1",
                },
                {
                  text: "CO_S6_P1_paragraph2",
                },
              ],
            },
          ],
          pdfPath: "/pdf/MES6-PDF.pdf",
          storyLinePath: "jeu-questionnaire/situation6/jeu.html",
          storyLineReady: true,
          audioUrl: "/audio/scene6/Un environnement riche_021.mp3",
        },
        {
          id: "id-situation-7",
          principles: [
            {
              paragraphs: [
                {
                  text: "CO_S7_P1_paragraph1",
                },
                {
                  text: "CO_S7_P1_paragraph2",
                },
              ],
            },
          ],
          pdfPath: "/pdf/MES7-PDF.pdf",
          storyLinePath: "jeu-questionnaire/situation7/jeu.html",
          storyLineReady: true,
          audioUrl: "/audio/scene7/Cultiver des saines habitudes de vie_021.mp3",
        },
        {
          id: "id-situation-8",
          principles: [
            {
              paragraphs: [
                {
                  text: "CO_S8_P1_paragraph1",
                },
                {
                  text: "CO_S8_P1_paragraph2",
                },
              ],
            },
          ],
          pdfPath: "/pdf/MES8-PDF.pdf",
          storyLinePath: "jeu-questionnaire/situation8/jeu.html",
          storyLineReady: true,
          audioUrl: "/audio/scene8/On joue dehors_021.mp3",
        },
        {
          id: "id-situation-9",
          principles: [
            {
              paragraphs: [
                {
                  text: "CO_S9_P1_paragraph1",
                  popover: "CO_S9_P1_paragraph1_popover",
                  popover2: "CO_S9_P1_paragraph1_popover2",
                },
              ],
            },
          ],
          pdfPath: "/pdf/MES9-PDF.pdf",
          storyLinePath: "jeu-questionnaire/situation9/jeu.html",
          storyLineReady: true,
          audioUrl: "/audio/scene9/MES1-7.mp3",
        },
        {
          id: "id-situation-10",
          principles: [
            {
              paragraphs: [
                {
                  text: "CO_S10_P1_paragraph1",
                },
                {
                  text: "CO_S10_P1_paragraph2",
                },
                {
                  text: "CO_S10_P1_paragraph3",
                },
              ],
            },
          ],
          pdfPath: "/pdf/MES10-PDF.pdf",
          storyLinePath: "jeu-questionnaire/situation10/jeu.html",
          storyLineReady: true,
          audioUrl: "/audio/scene10/MES2-7.mp3",
        },
        {
          id: "id-situation-11",
          principles: [
            {
              paragraphs: [
                {
                  text: "CO_S11_P1_paragraph1",
                },
                {
                  text: "CO_S11_P1_paragraph2",
                },
              ],
            },
          ],
          pdfPath: "/pdf/MES11-PDF.pdf",
          storyLinePath: "jeu-questionnaire/situation11/jeu.html",
          storyLineReady: true,
          audioUrl: "/audio/scene11/MES3-7.mp3",
        },
        {
          id: "id-situation-12",
          principles: [
            {
              paragraphs: [
                {
                  text: "CO_S12_P1_paragraph1",
                },
              ],
            },
          ],
          pdfPath: "/pdf/MES12-PDF.pdf",
          storyLinePath: "jeu-questionnaire/situation12/jeu.html",
          storyLineReady: true,
          audioUrl: "/audio/scene12/MES4-7.mp3",
        },
      ],

      // Images
      starImage: require("@/assets/icons/orange_star.png"),

      // Variables
      skipStoryLineCheat: false, // TBD change to true to skip storyline
      principleNumber: 0,
      starWidth: 200,
    };
  },
  computed: {},
  created() {
    this.setArea(this.areaName);
    this.setSituation(this.situationName);
  },
  methods: {
    getConclusionAreaClass() {
      if (this.newVersion()) {
        return "bg-select-conclusion-area bg-popup-area-new";
      }
      return "bg-select-conclusion-area";
    },
    onPDFClicked() {
      var audioRef = this.$refs[this.getPDFAudioRef()];
      if (audioRef != null) {
        this.pauseAllAudio();
        audioRef.playAudio();
      }
    },
    getCurrentPrinciple() {
      return this.getPrinciples()[this.principleNumber];
    },
    getPrinciples() {
      return this.situations[this.getCurrentSituation()].principles;
    },
    getPdfPath() {
      return this.situations[this.getCurrentSituation()].pdfPath;
    },
    getNextButtonLabel() {
      if (!this.isLastPage()) {
        return this.LG("CO_nextButtonLabel");
      } else {
        return this.LG("CO_quizButtonLabel");
      }
    },
    getCurrentSituation() {
      return this.$store.state.gamestate.situation;
    },
    isLastPage() {
      if (this.principleNumber >= this.situations[this.getCurrentSituation()].principles.length - 1) {
        return true;
      }
      return false;
    },
    onNextButtonClicked() {
      if (this.isLastPage()) {
        // Removed intro page, go straight to storyline now

        if (this.situations[this.getCurrentSituation()].storyLineReady == true && this.skipStoryLineCheat == false) {
          window.location.href = "/" + this.situations[this.getCurrentSituation()].storyLinePath;
        } else {
          // Skip the story line, as it's not ready yet
          this.$router.push(`/${this.areaName}/${this.situationName}/sommaire`);
        }
      } else {
        this.principleNumber++;
      }
    },
    getStarCss() {
      var offsetX = Number(this.starWidth) * -0.65;
      var style = "position: absolute;  top: -10px; left: " + offsetX + "px;";
      return style;
    },
    hasIntroAudio() {
      if (this.getIntroAudio() == null) {
        return false;
      }
      return true;
    },
    getIntroAudio() {
      return this.situations[this.getCurrentSituation()].audioUrl;
    },
    getIntroAudioRef() {
      return "introAudioRef";
    },
    hasPDFAudio() {
      if (this.getPDFAudio() == null) {
        return false;
      }
      return true;
    },
    getPDFAudio() {
      return this.audioPDF;
    },
    getPDFAudioRef() {
      return "pdfAudioRef";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import url("https://fonts.googleapis.com/css?family=Poppins");

.bg-select-conclusion-area {
  background-color: white;
  color: black;
  font-family: "Poppins";
  font-size: 17px;
  max-width: 900px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  padding: 25px;
  position: relative;
  padding-left: 50px;
  padding-right: 50px;
  padding-bottom: 50px;
}

.leave-space {
  margin-right: 10px;
}

.funky-wider {
  width: 215px !important;
}

@media only screen and (max-width: 600px) {
  .bg-select-conclusion-area {
    max-width: 450px;
  }
}
</style>
